import { render, staticRenderFns } from "./OrderFormAlgolia.vue?vue&type=template&id=94fe98b2&scoped=true&"
import script from "./OrderFormAlgolia.vue?vue&type=script&lang=js&"
export * from "./OrderFormAlgolia.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormAlgolia.vue?vue&type=style&index=0&id=94fe98b2&prod&scoped=true&lang=css&"
import style1 from "./OrderFormAlgolia.vue?vue&type=style&index=1&id=94fe98b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fe98b2",
  null
  
)

export default component.exports